// import httpManager from '@/app/shared/utils/httpManager'
import httpManager from "../../utils/httpManager";

export async function fetchTablePreferences(scope) {
  const url = `/users/table-preferences/${scope}`;
  const response = await httpManager.get(url);
  return response.data;
}
